import { useStore } from 'dg-web-shared/lib/Flux.tsx';
import { useLanguage } from 'dg-web-shared/lib/Localization.tsx';
import { SingleSelection } from '../../ui/labeled-elements/SingleSelection.tsx';
import * as Text from '../../common/i18n/Text.ts';
import { tomFilterTexts } from '../i18n/TomTexts.ts';
import * as TomState from '../state/TomState.ts';
import { tomSelectionText } from './TomFilterHalfSlideIn.tsx';

export interface TomFilterTexts {
    filterTitle: Text.Translation;
    dismantled: Text.Translation;
}

export function TomsFilterSelection({
    selectedToms,
    onOpenSlideIn,
    onClear,
}: {
    selectedToms: number[];
    onOpenSlideIn: () => void;
    onClear: () => void;
}) {
    const { storeState } = useStore(store => ({
        toms: TomState.List.get(store),
    }));
    const { language } = useLanguage();

    const texts = tomFilterTexts[language];
    const hasTomSelected = selectedToms.length > 0;

    return (
        <div>
            <SingleSelection
                label={texts.filterTitle()}
                focused={false}
                selection={tomSelectionText(
                    selectedToms,
                    storeState.toms.data.length,
                )}
                onClick={() => onOpenSlideIn()}
                onClear={hasTomSelected ? () => onClear() : null}
            />
        </div>
    );
}
